// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__HPkGU","spinnerContainerCircle":"Spinner_spinnerContainerCircle__3Zqm0","rotating-circle":"Spinner_rotating-circle__t-E9K"};